;(function () {
	'use strict';//Indicating browser should run only in java script mode
	angular
		.module('EMR.Home')
		.service('VideoChatCommonService', VideoChatCommonService)

	VideoChatCommonService.$inject = ['CommonPostService'];

	function VideoChatCommonService(CommonPostService) {
		//############# GET THE USERS LIST TO SHOW IN MULTIPLE CLIENTS SCHEDULER  BLOCK START   ##################
		//*******PURPOSE            : THIS METHOD IS USED TO GET THE LIST USERS TO SHOW IN ALL PROVIDERS SCHEDUELR 
		//*******CREATED BY         : HEAMNTH U
		//*******CREATED DATE       : MAY 11 2018
		//*******MODIFIED DEVELOPER : DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
		var videoChatGenerateVideoChatLink = function (postData) {

			postData.practicemodel = EMRPracticeModel;

			return CommonPostService.httpPostData('POST', CommonPostService.EHR_Appts_Common_API() + "GenerateVideoChatLink", postData).then(function (result) {
				return result;
			});
		};
		//#############GET THE RECURRING APPTS SCHEDULER GENERATION AND MAX SLOTS VALIDATION DATES LIST BLOCK END  ##################

		return {
			videoChatGenerateVideoChatLink: videoChatGenerateVideoChatLink,
		}
	}
})();